import { render } from "./SuccessMessage.vue?vue&type=template&id=3c8e86eb&scoped=true"
import script from "./SuccessMessage.vue?vue&type=script&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&lang=js"

import "./SuccessMessage.vue?vue&type=style&index=0&id=3c8e86eb&scoped=true&lang=css"

import exportComponent from "/Users/farhad/Hemsidan/fartow-se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8e86eb"]])

export default __exports__